import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { BaseRequestService } from "app/_services/base.service";
import { CommonService } from "app/_services/common.service";
import { MyToastrService } from "app/_services/toastr.service";
import { LoaderService } from "app/_services/loader.service";
import { Subject, takeUntil } from "rxjs";
import { FormsModule, NgForm, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { DirectivesModule } from "app/-directives/-directives.module";
import { MaterialModule } from "app/material.module";
import { DynamicFormComponent } from "app/modules/shared/forms/dynamic-form/dynamic-form.component";
import { TableComponent } from "app/modules/shared/table/table.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { AppFilterPipeModule } from "app/_filters/app.filter-pipe.module";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { FuseAlertComponent } from "@fuse/components/alert";

@Component({
  selector: "app-partner-settings",
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    FuseAlertComponent,
    AppFilterPipeModule,
    DirectivesModule,
    TableComponent,
    MaterialModule,
    DynamicFormComponent,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./partner-settings.component.html",
  styleUrls: ["./partner-settings.component.scss"],
})
export class PartnerSettingsComponent {
  panelOpenState = true;
}
